export function isActiveCampaignEnabled(): boolean {
  return Boolean(window.config?.activeCampaignEnabled);
}
